import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { useMemo } from 'react';
import { formatValueAsString } from '../../../../../utils/helpers';
import { TPolygonCallsItem } from '../../../kpiTypes';
import { ChartContainer } from '../../../../../shared/components/charts/ChartContainer';

interface IChartDataProps {
	data: TPolygonCallsItem[];
}

const ShipyardVisitsChart: React.FC<IChartDataProps> = ({ ...props }) => {
	const formatOptions = useMemo(() => ({ minimumFractionDigits: 0, maximumFractionDigits: 2 }), []);

	let transformedData = props.data.map((entry) => ({
		startTime: new Date(entry.startTime).toLocaleDateString('default', {
			day: 'numeric',
			month: 'short',
			year: '2-digit',
		}),
		'In Shipyard': entry.portActivity === 'In Shipyard' ? entry.totalTimeInPort : 0,
		portName: entry.portName,
	}));

	if (!transformedData || transformedData.length === 0) {
		return <div className="w-full h-full flex items-center justify-center">No data available</div>;
	}
	
	transformedData = transformedData.filter((item) => item['In Shipyard'] > 0);

	const options: AgChartOptions = {
		data: transformedData,
		series: [
			{
				type: 'bar',
				xKey: 'startTime',
				yKey: 'In Shipyard',
				stacked: true,
				fill: '#F0D035',
				tooltip: {
					renderer(params) {
						return {
							data: undefined,
							title: params.datum['portName'],
							heading:
								new Date(params.datum['startTime']).toLocaleString('default', {
									day: 'numeric',
									month: 'numeric',
									year: 'numeric',
								}) +
								' : ' +
								formatValueAsString(params.datum['In Shipyard'], formatOptions, '', '', ''),
						};
					},
				},
			},
		],
		axes: [
			{
				type: 'category',
				position: 'bottom',
				label: {
					autoRotate: true,
					rotation: transformedData.length > 5 ? -90 : 0,
					formatter: (params: any) => {
						return `${new Date(params.value).toLocaleString('default', { day: 'numeric', month: 'short', year: '2-digit' })}`;
					},
				},
			},
			{
				type: 'number',
				position: 'left',
				title: { text: 'Time (Days)' },
				nice: false,
			},
		],
		legend: {
			position: 'top',
			item: {
				marker: {
					shape: 'circle',
				},
			},
		},
	};

	return (
		<ChartContainer data={options.data} filename="port_calls_data" buttonPosition="top-right">
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default ShipyardVisitsChart;
